export const PaymentProvidersTypes = {
  STRIPE: "STRIPE",
  PAYPAL: "PAYPAL",
  FLUIDPAY: "FLUIDPAY"
};

export const PaymentProvidersNames = {
  STRIPE: "Stripe",
  PAYPAL: "PayPal",
  FLUIDPAY: "FluidPay"
};
